var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDanielAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#B5E2DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_311_1611",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_311_1611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1014 1197.33C1010.97 1199.5 1007.5 1201.66 1004.47 1203.83C1001 1206 997.967 1208.16 994.5 1209.9C991.467 1211.63 988.867 1213.36 985.833 1215.1C985.4 1215.53 984.967 1215.53 984.533 1215.96C974.567 1222.03 964.167 1227.66 953.767 1232.86C950.733 1234.6 947.267 1236.33 944.233 1237.63C944.233 1237.63 943.8 1238.06 943.367 1238.06C939.9 1239.8 936.433 1241.53 932.967 1243.26C926.033 1246.73 918.667 1249.76 911.733 1252.8C908.267 1254.53 904.367 1255.83 900.9 1257.13C897.433 1258.43 893.533 1260.16 890.067 1261.46C886.6 1262.76 882.7 1264.5 879.233 1265.8C879.233 1265.8 879.233 1265.8 878.8 1265.8C875.333 1267.1 871.433 1268.4 867.967 1269.7C860.167 1272.3 851.933 1274.9 844.133 1277.5C841.533 1278.36 838.5 1279.23 835.9 1280.1C827.667 1282.7 819.433 1284.86 811.2 1286.6C808.167 1287.46 805.133 1287.9 801.667 1288.76C793.867 1290.5 785.633 1292.23 777.833 1293.96C776.1 1294.4 774.8 1294.4 773.067 1294.83C770.467 1295.26 767.433 1295.7 764.833 1296.13C760.933 1296.56 757.467 1297.43 753.567 1297.86C751.833 1298.3 750.1 1298.3 748.367 1298.73C746.2 1299.16 743.6 1299.6 741 1299.6C734.067 1300.46 726.7 1301.33 719.767 1302.2C717.6 1302.63 715 1302.63 712.833 1303.06H712.4C709.367 1303.5 706.333 1303.5 703.3 1303.93C700.267 1304.36 697.233 1304.36 694.2 1304.36C692.467 1304.36 690.3 1304.8 688.567 1304.8C685.1 1304.8 682.067 1305.23 679.033 1305.23C674.7 1305.23 670.8 1305.66 666.467 1305.66C662.133 1305.66 658.233 1305.66 653.9 1305.66C650.867 1305.66 647.833 1305.66 644.8 1305.66C462.367 1303.06 297.7 1225.5 180.7 1102.43C180.7 1102.43 180.7 1102 180.267 1102C193.7 1075.56 243.534 1027.9 295.534 988.465C361.4 938.632 454.567 907.865 454.567 907.865C454.567 907.865 515.667 897.898 742.3 945.132C915.2 981.532 988.867 1129.3 1014 1197.33Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.4 1065.16C781.3 1109.8 722.367 1136.23 623.134 1096.36C501.367 1046.96 454.567 907.865 454.567 907.865C448.067 808.198 432.9 722.832 432.9 722.832C573.734 710.698 740.134 875.365 740.134 875.365L759.2 956.832C760.934 963.765 764.4 969.832 769.6 974.165C778.7 989.765 796.467 1036.56 790.4 1065.16Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.6 974.599C686.833 970.265 625.733 958.132 560.3 840.699C615.767 889.665 681.2 908.299 750.1 916.965L759.2 956.832C760.933 964.199 764.4 970.265 769.6 974.599Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.767 452.432C948.567 488.832 952.467 518.298 931.233 615.365C910 712.432 950.733 809.498 848.467 898.332C779.567 958.132 659.1 969.398 562.9 903.965C530.4 881.865 500.5 851.098 476.233 810.798C457.167 779.165 435.067 749.265 410.367 721.965C376.133 684.698 334.967 609.732 355.333 477.132C388.267 261.332 601.9 236.632 728 260.465C854.1 284.298 919.533 356.232 940.767 452.432Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.067 621.865C526.067 621.865 512.633 556.865 449.367 564.665C394.767 571.598 375.7 702.465 499.633 738.865",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.734 679.498C495.734 679.498 480.134 669.532 481.867 652.198C484.467 631.832 481.867 619.265 472.334 615.365C448.501 605.398 443.734 633.132 444.601 636.598",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.367 721.532C826.367 721.532 842.833 722.398 858.433 703.765C867.1 693.365 874.467 680.365 869.7 676.465C864.933 672.132 786.5 684.265 781.3 694.665C776.1 705.065 806.433 721.532 826.367 721.532Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.367 575.932C839.367 575.932 840.234 617.098 866.667 663.032C878.367 683.398 860.601 716.765 822.034 722.398",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M604.501 743.632C629.151 743.632 649.134 727.141 649.134 706.799C649.134 686.456 629.151 669.965 604.501 669.965C579.85 669.965 559.867 686.456 559.867 706.799C559.867 727.141 579.85 743.632 604.501 743.632Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M924.3 670.832C923 695.098 923.434 718.932 921.7 742.765C902.634 738.432 888.767 724.132 888.767 707.232C888.767 689.032 903.933 674.298 924.3 670.832Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.176 903.567C377.176 903.567 440.442 878.433 452.142 877.567L453.009 887.533C453.009 887.533 402.742 909.2 399.709 912.667C396.676 916.133 377.176 903.567 377.176 903.567Z",
    fill: "#7E5D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.04 1466.03H62.5762C62.5762 1466.03 69.0762 1264.97 134.943 1121.53C184.776 1013.2 304.376 941.7 391.476 910.5C416.176 901.833 435.243 892.3 453.01 887.533C453.01 889.7 454.309 905.733 454.309 907.466C454.309 907.466 526.243 1006.7 686.576 1005.4C782.776 1004.97 755.909 942.566 755.909 942.566C764.143 940.833 771.943 938.666 779.743 936.066C782.343 935.2 800.543 927.833 802.709 926.966C858.609 941.7 927.076 983.3 1026.31 1066.5C1138.11 1160.53 1158.04 1466.03 1158.04 1466.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.076 1466.03L257.576 1305.27",
    stroke: "#544D4D",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.68 1250.67C1033.68 1250.67 1020.68 1282.3 1024.58 1313.93C1028.48 1345.57 1039.74 1391.93 1023.71 1466.03",
    stroke: "#544D4D",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.176 903.567C385.409 900.967 399.709 903.567 404.042 910.934C420.942 938.667 461.676 1019.7 478.576 1180.47C492.009 1306.13 471.642 1532.33 471.642 1532.33L51.3091 1512.4C51.3091 1512.4 63.8758 1298.77 100.709 1155.33C136.676 1016.23 231.142 953.834 377.176 903.567Z",
    fill: "#755B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.109 930C813.109 930 947.009 1181.77 908.009 1518.03H1197.48C1197.48 1518.03 1195.74 1289.67 1130.74 1144.93C1065.74 1000.2 838.243 919.167 838.243 919.167C838.243 919.167 823.943 926.1 813.109 930Z",
    fill: "#755B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.109 930L802.708 926.967C802.708 926.967 817.875 919.6 824.375 915.267L828.275 913.1C828.275 913.1 849.075 922.634 856.442 926.1C863.809 929.567 830.875 945.6 830.875 945.6C830.875 945.6 814.409 930.434 813.109 930Z",
    fill: "#7E5D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.809 1140.17C473.809 1140.17 459.076 1098.13 425.709 1060.87C394.942 1026.2 338.609 972.467 334.709 960.334C327.342 935.634 373.276 842.467 445.209 809.967C445.209 810.4 445.209 810.834 445.209 811.267C445.209 811.7 445.209 812.134 445.209 813C445.209 813.867 445.209 814.734 445.642 815.6C445.642 816.9 446.076 818.2 446.076 819.5C446.076 820.367 446.076 820.8 446.509 821.667C449.542 847.667 452.142 876.7 454.309 907.467V907.9C454.309 907.9 434.376 914.4 448.676 1013.63C452.576 1037.47 467.309 1079.93 473.809 1140.17Z",
    fill: "#4B3C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.942 1153.6C888.942 1153.6 859.909 1040.93 845.609 1004.97C831.309 969.433 804.442 929.133 803.142 926.967C820.042 919.167 835.209 909.2 848.642 897.5C862.076 885.8 872.909 874.1 882.009 862.4C892.842 874.533 957.409 947.333 964.342 987.2C972.142 1031.4 915.809 1050.47 888.942 1153.6Z",
    fill: "#4B3C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.802 526.549C755.216 527.849 762.491 517.882 759.068 508.349C757.356 503.149 754.36 498.382 749.653 495.349C735.104 486.249 680.759 485.382 652.088 506.182C626.841 525.249 703.01 520.482 745.802 526.549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.333 531.316C856.631 531.316 851.924 521.349 855.775 513.116C857.915 508.782 860.91 504.882 865.189 502.716C878.455 496.216 913.972 500.116 929.805 522.216C943.926 541.716 899.851 530.882 864.333 531.316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.824 581.149C703.437 567.282 660.218 577.682 660.218 577.682",
    stroke: "black",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.854 589.816C899.854 589.816 888.728 577.683 847.648 587.216",
    stroke: "black",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.184 776.042C800.618 790.342 779.384 826.742 738.218 809.842C698.784 793.808 687.084 718.408 743.418 754.375C772.884 773.008 790.651 776.042 800.184 776.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.417 774.308C808.417 774.308 790.217 784.275 743.417 754.375C687.517 718.408 698.784 793.808 738.217 809.842C779.384 826.742 800.617 789.908 800.184 776.042",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.284 765.208C705.284 765.208 734.751 784.708 743.418 782.975C752.518 781.675 751.217 794.242 792.384 795.542",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.833 633.167H657.866C631.433 633.167 610.2 611.933 610.2 585.5V544.333C610.2 517.9 631.433 496.667 657.866 496.667H758.833C785.266 496.667 806.5 517.9 806.5 544.333V585.5C806.5 611.933 784.833 633.167 758.833 633.167Z",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.033 496.667H883.199C865.866 496.667 851.566 510.967 851.566 528.3V566C857.633 587.667 866.299 608.467 879.299 627.1C880.599 627.1 881.899 627.533 883.199 627.533H933.033C950.366 627.533 964.666 613.233 964.666 595.9V528.3C965.1 510.533 950.799 496.667 933.033 496.667Z",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.5 536.1C821.233 534.367 839.867 533.067 855.467 534.8",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.2 539.134L509.667 542.6",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.407 352.902C932.64 464.269 843.373 445.636 759.74 415.302C648.373 374.569 550.44 407.502 550.007 508.036C549.14 655.369 512.307 610.736 508.407 605.102C498.873 586.902 478.507 564.369 439.94 569.136C389.24 575.636 369.307 687.436 463.773 733.369C480.24 817.002 435.173 809.202 435.173 809.202C420.007 747.669 292.607 616.802 292.173 530.569C292.173 414.436 350.673 381.502 350.673 381.502C352.407 300.469 436.907 211.202 579.04 214.236C721.173 216.836 808.273 212.936 836.007 179.569C863.74 145.336 994.173 241.536 963.407 352.902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.874 486.802C962.54 514.969 950.407 536.636 933.507 552.669C940.007 505.436 936.541 482.902 930.907 456.469C918.774 402.303 892.774 355.503 849.44 320.836C871.107 319.103 893.207 323.869 913.14 336.436C913.14 336.003 984.64 365.036 966.874 486.802Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanielAvatar);
export default __webpack_public_path__ + "static/media/daniel-avatar.f6481d1c4ad861ba30b6524714a11688.svg";
export { ForwardRef as ReactComponent };